import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppContext } from "../../contexts/AppContext";
import { getLiveEvents } from "../../services/liveevents";
import LiveEventsTable from "../../components/Tables/LiveEventsTable";
import Select from "react-select";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import {
  getLocalDateFromString,
  shortDateTimeFormatter,
} from "../../utils/utils";
import { Button } from "../../components/StyledElements";
import { useLiveEvents } from "../../contexts/LiveEventsContext";


const SmallButton = styled.div`
  height: 30px;
  width: 24px;
  background-color: #f3f4f6; 
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0a6b1;
  cursor: pointer;

  &.selected {
    background-color: var(--button-selected-bg); 
  }
  &.selected > * {
    color: var(--button-bg);

  }
`

const VerticalSeparator = styled.div`
  width: 1px;
  height: 30px;
  background-color: #eceff4;
  margin-left: 20px;
  margin-right: 20px;
`

const LiveEventsGridWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

`

const LiveEventCardWrapper = styled.div`
    position: relative;
    border: 1px solid var(--content-item-border-color);
    color: var(--main-font-color);
    width: 300px;
    height: 485px;
    max-height: 485px;
    background-color: var(--card-bg);
    border-radius: 5px;
    box-shadow: var(--content-item-box-shadow);
    padding: 20px 20px 0 20px;
`

const LiveEventStatus = styled.div`
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    background-color: var(--main-bg);
    width: auto;
    height: auto;
    padding: 2px 10px 2px 10px;
    border-radius: 20px;
    display: inline-block;

    &.scheduled {
      background-color: #dbfbe8;
      color: #309053; 
    }
}
`

const LiveEventTitle = styled.div`
    font-weight: bold;
    font-size: 20px;
    margin-top: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
`

const LiveEventDescription = styled.div`
    font-weight: normal;
    font-size: 16px;
    margin-top: 10px;
    font-style: italic;
    overflow: auto;
    max-height: 140px;
    height: 140px;
    margin-bottom: 10px;
`

const LiveEventInfo = styled.div`
    font-size: 15px;
    margin-bottom: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    & > div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
}
`
const LiveEventData = styled.div`
    position: relative;
    width: 300px;
    margin-left: -20px;
    font-size: 14px;
    color: #a0a6b1;
    background-color: var(--card-inset-bg);
    padding: 10px 20px;
    border-top: 1px solid var(--main-bg);
    border-bottom: 1px solid var(--main-bg);
`;

const LiveEventOpenLink = styled.a`
    font-size: 15px;
    color: var(--sidebar-active-item-color);
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
`;

const SearchBar = styled.div`
  width: calc(100% - 20px);
  border-radius: 5px;
  border: 1px solid var(--content-item-border-color);  
  background-color: var(--card-bg);
  padding: 10px 20px;
  box-shadow: var(--content-item-box-shadow);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

const SearchBox = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid #d2d6dd;
  background-color: #f8fafb; 
  display: flex;
  align-items: center;
  padding-left: 10px;

  & * {
    color: #717886;
  }

  & input {
    height: 100%;
    border: none;
    outline: none !important;
    background: transparent;
    width: 250px;
  }

  & input:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }
}
`

const LiveEventToolBarWrapper = styled.div`
  width: 300px;
  margin-left: -20px;
  height: 50px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  padding: 0;
`

const LiveEventToolBarButton = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--main-bg);
  cursor: pointer;

  & * {
    font-size: 20px;
 }

`;

export const LiveEvents = () => {
  const activeUser = useSelector((state) => state.users.activeUser);
  const { selectedClient } = useContext(AppContext);
  //const [liveEvents, setLiveEvents] = useState([]);
  const [filteredLiveEvents, setFilteredLiveEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("newest-first")
  const [display, setDisplay] = useState("grid");
  const navigate = useNavigate();

  const { liveEvents, setLiveEvents, setSelectedEvent, setUpdatedEvent, selectedEvent } = useLiveEvents();

  const sortByOptions = [
    { label: "Newest First", value: "newest-first" },
    { label: "Open Date First", value: "open-date-first" },
    { label: "Open Date Last", value: "open-date-last" },
    { label: "Start Date First", value: "start-date-first" },
    { label: "Start Date Last", value: "start-date-last" },
  ]

  useEffect(() => {
    console.log("!!! FETCHING LIVE EVENTS");
    const fetchLiveEvents = async () => {
      try {
        const liveEvents = await getLiveEvents(selectedClient.public_id ?? selectedClient.id);
        setLiveEvents(liveEvents);
        setFilteredLiveEvents(liveEvents);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchLiveEvents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);


  useEffect(() => {
    if (!searchTerm) {
      setFilteredLiveEvents(liveEvents);
      return;
    }

    setFilteredLiveEvents(liveEvents.filter((liveEvent) => {
      console.log(liveEvent.title, liveEvent.description)
      return `${liveEvent.status} ${liveEvent.title} ${liveEvent.description}`.toLowerCase().includes(searchTerm.toLowerCase())
    }))

    // eslint-disable-next-line
  }, [searchTerm])

  const LiveEventToolBar = ({ liveEvent }) => {
    return (
      <LiveEventToolBarWrapper>
        {/* Toolbar buttons can be added here */}
        <LiveEventToolBarButton onClick={() => {
          const { public_id } = liveEvent;
          if (activeUser?.user_type.match(/client/)) {
            navigate(`/client/live-event/${public_id}#presenter`);
          } else {
            navigate(`/live-event/${public_id}#presenter`);
          }
        }}><Icon icon="mdi:play" /></LiveEventToolBarButton>
        <LiveEventToolBarButton
          onClick={() => {
            if (selectedEvent?.public_id !== liveEvent.public_id) {
              setSelectedEvent(null);
              setUpdatedEvent(null);
            }
            if (activeUser?.user_type.match(/client/)) {
              navigate(`/client/live-event/edit/${liveEvent.public_id}`);
            } else {
              navigate(`/live-event/edit/${liveEvent.public_id}`);
            }
          }}
        ><Icon icon="mdi:edit" /></LiveEventToolBarButton>
        <LiveEventToolBarButton><Icon icon="mdi:link" /></LiveEventToolBarButton>
        <LiveEventToolBarButton><Icon icon="mdi:trash-can" /></LiveEventToolBarButton>
      </LiveEventToolBarWrapper>
    )
  }

  const getLiveEventStatus = (liveEvent) => {
    const now = new Date();
    const startDate = getLocalDateFromString(liveEvent.start_date);
    const endDate = getLocalDateFromString(liveEvent.completed_at);

    if ((liveEvent.status === "scheduled" || (startDate && startDate > now)) || (liveEvent.status === "initialized" && liveEvent.event_type.includes("recorded", "scheduled"))) {
      return "scheduled";
    }

    if (liveEvent.status === "ended" || (endDate && endDate < now)) {
      return "ended";
    }

    return liveEvent.status
  }

  const LiveEventCard = ({ liveEvent }) => {
    const liveEventStatus = getLiveEventStatus(liveEvent);
    return (
      <LiveEventCardWrapper key={liveEvent.id}>
        <div style={{ height: "240px", minHeight: "240px" }}>
          <LiveEventStatus className={liveEventStatus}>{liveEventStatus}</LiveEventStatus>
          <LiveEventTitle
            title={liveEvent.title}
          >{liveEvent.title}</LiveEventTitle>
          <LiveEventDescription>{liveEvent.description ?? "No event description"}</LiveEventDescription>
        </div>
        {liveEventStatus === "ended" &&
          (
            <>
              <LiveEventInfo>
                <Icon icon="mdi:calendar-blank" />
                <div style={{ marginLeft: "10px" }}>Started: {liveEvent?.start_date ? shortDateTimeFormatter.format(getLocalDateFromString(liveEvent.start_date)) : "-"}</div>
              </LiveEventInfo>
              <LiveEventInfo>
                <Icon icon="mdi:clock" />
                <div style={{ marginLeft: "10px" }}>Ended: {liveEvent?.completed_at ? shortDateTimeFormatter.format(getLocalDateFromString(liveEvent.completed_at)) : "-"}</div>
              </LiveEventInfo>
              <LiveEventInfo>
                <Icon icon="mdi:people" />
                <div style={{ marginLeft: "10px" }}>{liveEvent.participant_count} users</div>
              </LiveEventInfo>
            </>
          )
        }

        {liveEventStatus === "scheduled" &&
          (
            <>
              <LiveEventInfo>
                <Icon icon="mdi:calendar" color={"var(--sidebar-active-item-color)"} style={{ fontWeight: "500" }} />
                <div style={{ marginLeft: "10px", fontWeight: "500" }}>Opens: {liveEvent.open_date ? shortDateTimeFormatter.format(getLocalDateFromString(liveEvent.open_date)) : "-"}</div>
              </LiveEventInfo>
              <LiveEventInfo>
                <Icon icon="mdi:clock" />
                <div style={{ marginLeft: "10px" }}>Starts: {liveEvent.start_date ? shortDateTimeFormatter.format(getLocalDateFromString(liveEvent.start_date)) : "-"}</div>
              </LiveEventInfo>
              <LiveEventInfo>
                <Icon icon="mdi:people" />
                <div style={{ marginLeft: "10px" }}>{liveEvent.participant_count} users</div>
              </LiveEventInfo>
            </>
          )
        }

        <LiveEventData>
          <div>ID: {liveEvent.id}</div>
          <div>PUB: {liveEvent.public_id.substr(0, 8)}...</div>
          <div style={{ position: "absolute", right: "20px", top: "10px", fontSize: "12px", color: "#a0a6b1" }}>
            <LiveEventOpenLink onClick={() => {

              const { public_id } = liveEvent;
              if (activeUser?.user_type.match(/client/)) {
                navigate(`/client/live-event/${public_id}#presenter`);
              } else {
                navigate(`/live-event/${public_id}#presenter`);
              }
            }}>
              Open Link <Icon icon="mdi:open-in-new" style={{ marginLeft: "5px" }} />
            </LiveEventOpenLink>
          </div>
        </LiveEventData>
        <LiveEventToolBar liveEvent={liveEvent} />
      </LiveEventCardWrapper>
    )
  }

  const LiveEventsGrid = () => {
    console.log("!!! FILTERED LIVE EVENTS: ", filteredLiveEvents);
    return (
      <LiveEventsGridWrapper>
        { filteredLiveEvents.map(liveEvent => {
          return <div key={liveEvent.id} style={{ marginRight: "24px", marginBottom: "24px" }}><LiveEventCard liveEvent={liveEvent} /></div>
        })
        }
      </LiveEventsGridWrapper>
    );
  }

  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        <div style={{ color: "var(--main-font-color)" }}>Live Events <span style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>({liveEvents.length > filteredLiveEvents.length ? `${filteredLiveEvents.length} of ${liveEvents.length}` : liveEvents.length})</span></div>
        <div style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>Manage scheduled and past live streams</div>
      </div>
      <div style={{ position: "absolute", right: "20px", top: "10px" }}>
        <Button
          onClick={() => {
            if (activeUser?.user_type.match(/client/)) {
              navigate(`/client/live-event/create`);
            } else {
              navigate(`/live-event/create`);
            }
          }}
        >+ Create Event</Button>
      </div>

      <div style={{ marginTop: "24px" }}>
        <SearchBar>
          <label style={{ marginRight: "10px", color: "var(--main-font-color)" }}>Sort by: </label>
          <Select
            label="Sort by"
            placeholder="Sort By"
            name="sortby"
            value={
              sortByOptions.find(
                (sb) =>
                  sb.value === sortBy
              )
            }
            options={sortByOptions}
            onChange={(e) => {
              setSortBy(e.value);
            }}
          />
          <VerticalSeparator />

          <SmallButton className={display === "list" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("list") }}>
            <Icon icon="material-symbols:list" />
          </SmallButton>
          <SmallButton className={display === "grid" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("grid") }}>
            <Icon icon="material-symbols:grid-view-outline" />
          </SmallButton>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <SearchBox>
              <Icon icon="material-symbols:search" />
              <input value={searchTerm} type="text" onChange={(e) => {
                setSearchTerm(e.target.value);
              }} />

              {searchTerm &&
                <div style={{ cursor: "pointer" }} onClick={() => setSearchTerm("")}>
                  <Icon icon="material-symbols:x-circle" />
                </div>
              }
            </SearchBox>
          </div>
        </SearchBar>
      </div>

      {
        display === "grid" &&
        <div style={{ marginTop: "24px" }}>
          <LiveEventsGrid />
        </div>
      }
      {
        display === "list" &&
        <LiveEventsTable
          liveEvents={filteredLiveEvents}
          onUpdated={(newLiveEvents) => {
            setLiveEvents(newLiveEvents);
          }}
        />
      }
    </div>
  );
};

export default LiveEvents;
